import moment from 'moment-timezone';

/**
 * แปลงเป็นปี พ.ศ. แล้ว format — ปลอดภัยกับวันที่ 29 ก.พ.
 *
 * เดิมใช้ .add(543, 'year') ซึ่ง moment จะ "หนีบ" 29 ก.พ. ของปีอธิกสุรทิน
 * ให้เหลือ 28 ก.พ. เมื่อปีปลายทาง (ค.ศ.+543) ไม่ใช่ปีอธิกสุรทิน
 * เช่น 2024-02-29 → "28/02/2567" ซึ่งผิดไป 1 วัน
 *
 * วิธีใหม่: ไม่ขยับตัววันที่เลย แต่แทน token ปี (YYYY/YY) ด้วยปี พ.ศ. ที่คำนวณแยก
 * โดยครอบด้วย [] ซึ่ง moment ถือเป็นข้อความตรงตัว
 */
function _toBuddhistFormat(momentDatetime, format) {
  var buddhistYear = momentDatetime.year() + 543;
  var escapedFormat = String(format)
    .replace(/YYYY/g, '[' + buddhistYear + ']')
    .replace(/YY/g, '[' + String(buddhistYear).slice(-2) + ']');

  return momentDatetime.locale('th').format(escapedFormat);
}

export function _convertTimezone(utcDateTime, timezone = 'Asia/Bangkok') {
  return moment.utc(utcDateTime).tz(timezone);
}

export function _formatDatetime(utcDateTime, format = 'YYYY-MM-DD HH:mm:ss', timezone = 'Asia/Bangkok') {
  var momentDatetime = _convertTimezone(utcDateTime, timezone);
  return momentDatetime.locale('th').format(format);
}

export function _formatDate(utcDateTime, format = 'YYYY-MM-DD HH:mm:ss', timezone = 'Asia/Bangkok') {
  var momentDatetime = _convertTimezone(utcDateTime, timezone);
  return _toBuddhistFormat(momentDatetime, format);
}

export function _formatDateDisplay(utcDateTime, format = 'DD MMMM YYYY', timezone = 'Asia/Bangkok') {
  var momentDatetime = _convertTimezone(utcDateTime, timezone);
  return _toBuddhistFormat(momentDatetime, format);
}

export function _formatSubDateDisplay(utcDateTime, format = 'DD MMM YY', timezone = 'Asia/Bangkok') {
  var momentDatetime = _convertTimezone(utcDateTime, timezone);
  return _toBuddhistFormat(momentDatetime, format);
}

export function _formatMonthDisplay(utcDateTime, format = 'MMMM YYYY', timezone = 'Asia/Bangkok') {
  var momentDatetime = _convertTimezone(utcDateTime, timezone);
  return _toBuddhistFormat(momentDatetime, format);
}

export function _formatYearDisplay(utcDateTime, format = 'YYYY', timezone = 'Asia/Bangkok') {
  var momentDatetime = _convertTimezone(utcDateTime, timezone);
  return _toBuddhistFormat(momentDatetime, format);
}

export function _formatDateTimeDisplay(utcDateTime, format = 'DD MMMM YYYY HH:mm:ss', timezone = 'Asia/Bangkok') {
  var momentDatetime = _convertTimezone(utcDateTime, timezone);
  return _toBuddhistFormat(momentDatetime, format);
}